import 'material-symbols'
import 'remixicon/fonts/remixicon.css'
import 'react-calendar/dist/Calendar.css'
import 'swiper/css'
import 'swiper/css/bundle'
import '@biartbt/biartd/styles/index.css'
import '@biartbt/biartd/styles/themes/trezo.css'
import './index.css'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Provider } from 'react-redux'
import { I18nextProvider } from 'react-i18next'
import { ToastProvider } from '@biartbt/biartd'
import i18n from './i18n/config'
import { store } from './store/store'
import App from './App'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <I18nextProvider i18n={i18n}>
          <ToastProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </ToastProvider>
        </I18nextProvider>
      </QueryClientProvider>
    </Provider>
  </StrictMode>,
)

